import { Navigate } from 'react-router-dom';
import { useControllerSocialMediaContext } from '../../hooks/ControllerSocialMedia';
import { useEffect } from 'react';
import RedirectLoader from './RedirectLoader';
import {
  getSocialErrorRouteFromStorage,
  isSocialRecoveryFlow,
  pushGtmEvent
} from '../../utils/GenericFunctions';

let isLoading = false;

export default function GoogleRedirect() {
  const { googleHandleCredentialResponse } = useControllerSocialMediaContext();

  const url = window.location.href;
  const regex = /code=([^&]+)/;
  const match = url.match(regex);

  async function handleGoogleRedirect() {
    if (match && !isLoading) {
      console.log('Autenticado pelo Google');
      isLoading = true;

      if (isSocialRecoveryFlow()) {
        pushGtmEvent('recovery_social_auth_success', { provider: 'google' });
      }

      const googleResponse = {
        code: decodeURIComponent(match[1])
      };
      console.log('URL do google', url);
      googleHandleCredentialResponse(googleResponse?.code);
    }
  }

  useEffect(() => {
    handleGoogleRedirect();
  }, []);

  useEffect(() => {
    if (isSocialRecoveryFlow()) {
      pushGtmEvent('recovery_social_auth_cancel', { provider: 'google' });
    }
  }, [match]);

  if (!match)
    return (
      <Navigate
        to={getSocialErrorRouteFromStorage()}
        state={{ socialConnectionError: true }}
        replace
      />
    );

  return <RedirectLoader />;
}
